/* Auto-generated returns form translations. Edit locales/pt-PT.json (returns.<lang>) then regenerate. */
window.RAG_RETURNS_I18N = {
  "pt": {
    "grp_delivered_on": "Entregue a",
    "grp_window_expired": "Prazo de devolução expirado",
    "c_title": "Devoluções, Trocas e Cancelamentos",
    "c_intro": "Solicite a sua devolução, troca ou cancelamento de forma simples no formulário abaixo.",
    "c_conditions": "<p>O processo de troca ou devolução é simples. Tem até 14 dias após a receção da encomenda para nos comunicar a intenção de troca ou devolução através deste formulário. Em caso de cancelamento os mesmos apenas são aceites antes da expedição da encomenda ou ínicio da personalização dos artigos.</p><p>Após submeter o pedido, deverá fazer-nos chegar o(s) artigo(s) para a morada indicada ou, quando aplicável, optar pelo serviço de recolha disponível no formulário. O pedido só será analisado após a recepção e validação dos artigos devolvidos.</p><p>Os artigos devem encontrar-se em estado original, sem sinais de uso, lavagem, odores, danos ou alterações, e sempre que aplicável, com etiquetas, embalagens e caixas originais.</p><p>Para garantir o correto processamento do pedido, pedimos que tenha em atenção:</p><ul><li>Indique o número da encomenda no envio ou na caixa ou com uma nota no interior;</li><li>Embale os artigos em caixa ou envelope fechado, de forma segura;</li><li>No caso de calçado, a caixa original deve ser protegida com uma embalagem exterior, não devendo ser utilizada diretamente como caixa de envio;</li><li>As trocas são habitualmente processadas até 5 dias úteis após receção e validação dos artigos devolvidos;</li><li>Em caso de troca, quando a nova expedição for realizada, enviaremos um email com o respetivo número de acompanhamento;</li><li>Os reembolsos são habitualmente processados entre 5 a 8 dias úteis após validação da devolução.</li><li>Por favor Não envie encomendas antes de preencher o formulário</li></ul><p>No caso de reembolso, se o pagamento tiver sido feito por cartão, PayPal, Klarna ou MB Way, o valor será reembolsado pela mesma via. Caso o pagamento tenha sido realizado por Multibanco, transferência bancária ou Payshop, será necessário indicar o IBAN e o nome do titular da conta.</p>",
    "c_ineligible": "Não se efetuam trocas, devoluções ou cancelamentos de artigos personalizados (com texto ou bordados) ou íntimos.",
    "c_intransit": "<p>A sua encomenda já foi expedida mas ainda não foi entregue. Nesta fase não é possível iniciar trocas ou devoluções pelo formulário. Pode <strong>recusar a entrega</strong> ao estafeta; o reembolso ou a troca só serão processados após a chegada da encomenda devolvida.</p>",
    "paid_badge": "Pago",
    "remove": "Remover",
    "sending": "A enviar…",
    "iban_ph": "PT50 0000 0000 0000 0000 0000 0",
    "holder_ph": "Nome completo",
    "required_mark": "*",
    "step_order": "1 · Encomenda",
    "step_items": "2 · Artigos",
    "step_exchange": "3 · Troca",
    "order_number_label": "Número da encomenda",
    "order_number_ph": "Ex: 1001",
    "email_label": "Email da encomenda",
    "email_ph": "o-seu@email.com",
    "help_prefix": "Não sabe o número da encomenda? Encontra-o no",
    "help_email_word": "email de confirmação",
    "help_received": "que recebeu, ou",
    "help_account": "na sua conta.",
    "help_login": "fazendo login na sua conta.",
    "search_btn": "Procurar encomenda",
    "searching": "A procurar…",
    "conditions_title": "Condições de troca e devolução",
    "address_label": "Morada para envio:",
    "pickup_inline_label": "Recolha no local",
    "pickup_inline_text": "podemos agendar a recolha do artigo, convenientemente embalado.",
    "pickup_link": "Link para recolha de artigos",
    "policy_link": "Ver política completa de trocas e devoluções",
    "summary_order": "Encomenda:",
    "summary_email": "Email:",
    "summary_payment": "Pagamento:",
    "summary_shipping": "Envio:",
    "within_yes": "Dentro dos 14 dias",
    "within_no": "Fora do prazo de 14 dias",
    "delivery_unfulfilled": "Por enviar",
    "delivery_label_printed": "Em expedição",
    "delivery_in_transit": "Em trânsito",
    "delivery_out_for_delivery": "Em distribuição",
    "delivery_delivered": "Entregue",
    "delivery_fulfilled": "Enviada",
    "actions_title": "O que pretende fazer?",
    "action_cancel_t": "Cancelar Encomenda",
    "action_cancel_d": "A encomenda ainda não foi enviada.",
    "action_withdrawal_t": "Resolver / Cancelar",
    "action_withdrawal_d": "Livre resolução — recusar a entrega.",
    "action_return_t": "Devolver",
    "action_return_d": "Reembolso após receção e avaliação.",
    "action_exchange_t": "Trocar",
    "action_exchange_d_pre": "Trocar de artigo/tamanho antes do envio.",
    "action_exchange_d": "Trocar por outro(s) artigo(s).",
    "no_actions": "Esta encomenda não reúne as condições para troca, devolução ou cancelamento (fora do prazo de 14 dias ou já enviada). Em caso de dúvida, contacte-nos.",
    "items_title": "Selecione os artigos",
    "qty_ordered": "Qtd. encomendada:",
    "qty": "Qtd.",
    "ineligible_fallback": "Artigo não elegível",
    "shipping_title": "Como nos faz chegar o(s) artigo(s)?",
    "ship_self": "Envio pelo próprio",
    "ship_self_desc": "Envie via CTT registado para a morada indicada.",
    "ship_pickup": "Recolha no local",
    "ship_pickup_desc": "Agendamos a recolha pelos CTT.",
    "pickup_country_only": "Disponível apenas para entregas em Portugal ou Espanha.",
    "refund_title": "Reembolso",
    "refund_original": "Forma de pagamento original",
    "refund_original_desc": "Cartão, MB Way, PayPal ou Klarna — sem dados adicionais.",
    "refund_original_desc_ok": "Reembolso na mesma forma de pagamento usada (cartão, MB Way, PayPal ou Klarna).",
    "refund_original_desc_iban": "Apenas válida para cartão, MB Way, PayPal ou Klarna.",
    "refund_iban": "Transferência bancária (IBAN)",
    "refund_iban_desc": "Necessário se o pagamento não permitir reembolso direto.",
    "refund_iban_desc_disabled": "Indisponível — o reembolso é feito na forma de pagamento original.",
    "refund_iban_desc_required": "Obrigatória para Multibanco, transferência bancária ou Payshop.",
    "iban_label": "IBAN",
    "iban_holder_label": "Nome do titular",
    "notes_label": "Observações (opcional)",
    "notes_ph": "Ex: motivo da devolução, indicações…",
    "back": "Voltar",
    "submit_order": "Submeter pedido",
    "submit_withdrawal": "Submeter resolução",
    "continue_exchange": "Continuar para a troca",
    "ex_recap_return": "Artigos a devolver",
    "ex_recap_swap": "Artigos a trocar",
    "ex_mode_title": "O que pretende em troca?",
    "ex_mode_variant": "Mesmo artigo, outra cor/tamanho",
    "ex_mode_variant_desc": "Escolha a nova variante de cada artigo.",
    "ex_mode_different": "Um artigo diferente",
    "ex_mode_different_desc": "Importe do carrinho os artigos pretendidos.",
    "ex_loading": "A carregar opções de troca…",
    "ex_swap_title": "Trocar por (cor / tamanho):",
    "ex_no_handle": "Para trocar este artigo, use “Importar do carrinho” abaixo.",
    "ex_no_variants": "Este artigo não tem outras variantes. Para trocar por outro artigo, use “Importar do carrinho”.",
    "ex_status_unavailable": "Combinação indisponível.",
    "ex_status_sold_out": "Esgotado nesta variante.",
    "ex_status_choose_diff": "Escolha uma cor ou tamanho diferente do atual.",
    "ex_status_new": "✓ Novo:",
    "ex_cart_hint": "Adicione ao carrinho da loja os artigos pretendidos e clique em “Importar do carrinho”. Pode ajustar quantidades ou remover abaixo.",
    "ex_cart_empty_note": "Adicione ao carrinho na loja os artigos pretendidos e clique em “Importar do carrinho”.",
    "ex_import_btn": "🛒 Importar do carrinho",
    "ex_cart_empty_err": "O seu carrinho está vazio. Adicione os artigos pretendidos na loja e volte a importar.",
    "ex_cart_error": "Erro ao importar o carrinho.",
    "ex_submit": "Submeter troca",
    "pickup_cost_label": "Custo da recolha:",
    "pickup_processed": "(processado pela loja online)",
    "pickup_buy": "Comprar recolha",
    "success_title": "Pedido submetido com sucesso",
    "success_msg": "Recebemos o seu pedido e enviámos um email de confirmação com todas as instruções e os próximos passos.",
    "success_ref": "Referência do pedido:",
    "err_not_found": "Encomenda não encontrada ou e-mail incorreto.",
    "err_comm": "Erro de comunicação. Por favor tente novamente.",
    "err_submit": "Não foi possível submeter o pedido. Por favor tente novamente.",
    "err_iban_required": "Indique o IBAN e o nome do titular para o reembolso.",
    "intransit_title": "Encomenda a caminho — ainda não entregue",
    "pickup_country_note": "*Válido apenas para Portugal e Espanha Continental",
    "l_order": "Encomenda:",
    "l_email": "Email:",
    "l_payment": "Pagamento:",
    "l_shipping": "Envio:",
    "badge_paid": "Pago",
    "within14": "Dentro dos 14 dias",
    "outside14": "Fora do prazo de 14 dias",
    "del_unfulfilled": "Por enviar",
    "del_label_printed": "Em expedição",
    "del_in_transit": "Em trânsito",
    "del_out_for_delivery": "Em distribuição",
    "del_delivered": "Entregue",
    "del_fulfilled": "Enviada",
    "act_cancel_t": "Cancelar Encomenda",
    "act_cancel_d": "A encomenda ainda não foi enviada.",
    "act_withdraw_t": "Resolver / Cancelar",
    "act_withdraw_d": "Livre resolução — recusar a entrega.",
    "act_return_t": "Devolver",
    "act_return_d": "Reembolso após receção e avaliação.",
    "act_exchange_t": "Trocar",
    "act_exchange_d": "Trocar por outro(s) artigo(s).",
    "act_exchange_d_pre": "Trocar de artigo/tamanho antes do envio.",
    "item_ineligible": "Artigo não elegível",
    "rf_orig_original": "Reembolso na mesma forma de pagamento usada (cartão, MB Way, PayPal ou Klarna).",
    "rf_iban_unavailable": "Indisponível — o reembolso é feito na forma de pagamento original.",
    "rf_orig_ibanonly": "Apenas válida para cartão, MB Way, PayPal ou Klarna.",
    "rf_iban_required": "Obrigatória para Multibanco, transferência bancária ou Payshop.",
    "rf_orig_unknown": "Cartão, MB Way, PayPal ou Klarna — sem dados adicionais.",
    "rf_iban_unknown": "Necessário se o pagamento não permitir reembolso direto.",
    "continue_withdrawal": "Submeter resolução",
    "continue_submit": "Submeter pedido",
    "exch_recap_return": "Artigos a devolver",
    "exch_recap_predispatch": "Artigos a trocar",
    "vs_loading": "A carregar opções de troca…",
    "vs_title": "Trocar por (cor / tamanho):",
    "vs_fallback_cart": "Para trocar este artigo, use “Importar do carrinho” abaixo.",
    "vs_no_variants": "Este artigo não tem outras variantes. Para trocar por outro artigo, use “Importar do carrinho”.",
    "vs_unavailable": "Combinação indisponível.",
    "vs_soldout": "Esgotado nesta variante.",
    "vs_choosediff": "Escolha uma cor ou tamanho diferente do atual.",
    "vs_new": "✓ Novo:",
    "exch_cart_empty": "Adicione ao carrinho na loja os artigos pretendidos e clique em “Importar do carrinho”.",
    "exch_cart_empty_err": "O seu carrinho está vazio. Adicione os artigos pretendidos na loja e volte a importar.",
    "exch_cart_error": "Erro ao importar o carrinho.",
    "success_ref_label": "Referência do pedido:",
    "pickup_deduct_pre": "Serão deduzidos",
    "pickup_deduct_post": "do valor a reembolsar.",
    "pickup_buy_pre": "A recolha tem um custo de",
    "pickup_buy_post": ". No ecrã final, após confirmar o pedido, será apresentado o link para comprar o artigo de recolha.",
    "pickup_same_addr_q": "A morada de recolha é a mesma da entrega?",
    "pickup_same_yes": "Sim, é a mesma",
    "pickup_same_no": "Não, indicar outra",
    "pickup_addr_name": "Nome do contacto",
    "pickup_addr_name_ph": "Quem entrega o volume aos CTT",
    "pickup_addr_phone": "Telefone",
    "pickup_addr_phone_ph": "Para contacto dos CTT",
    "pickup_addr_line": "Morada",
    "pickup_addr_line_ph": "Rua, número, andar",
    "pickup_addr_postal": "Código postal",
    "pickup_addr_postal_ph": "0000-000",
    "pickup_addr_city": "Localidade",
    "pickup_addr_city_ph": "Localidade",
    "pickup_day_label": "Qual o melhor dia para a recolha?",
    "pickup_day_ph": "Exemplos: Dia 20 de Janeiro, Terças e Quintas-feiras",
    "pickup_note_title": "Importante:",
    "pickup_note_body": "As recolhas são realizadas via CTT em dias úteis em horário laboral, não sendo possível agendar hora. Os artigos devem ser bem embalados em caixa ou envelope fechado para permitir o seu envio em segurança. Isto aplica-se também a caixas de calçado, que deverão ser embaladas de forma a serem protegidas.",
    "err_pickup_addr_required": "Indique a morada de recolha (morada, código postal e localidade).",
    "err_required_fields": "Preencha os campos obrigatórios assinalados a vermelho.",
    "ex_balance_title": "Acerto de valores",
    "ex_balance_intro_refund": "Do seu pedido de troca resulta um valor a seu favor, que lhe será reembolsado:",
    "ex_balance_intro_pay": "Do seu pedido de troca resulta um valor a pagar:",
    "ex_balance_intro_even": "Da sua troca não resulta qualquer valor a acertar.",
    "ex_balance_returned": "Devolvido",
    "ex_balance_new": "Novo(s)",
    "ex_balance_refund": "a reembolsar",
    "ex_balance_pay": "a pagar",
    "ex_balance_even": "Sem valor a acertar.",
    "ex_topay_note": "Há um valor a pagar pela diferença. Será comunicado posteriormente pela nossa equipa, com as instruções de pagamento.",
    "success_pickup_title": "Falta agendar a recolha",
    "success_pickup_msg": "Para concluir o agendamento da recolha, finalize a compra abaixo. A recolha só é agendada após o pagamento.",
    "badge_partial": "Parcial",
    "grp_unfulfilled": "Por enviar",
    "grp_in_transit": "A caminho",
    "grp_delivered": "Entregue",
    "grp_tracking": "Rastreio:",
    "choose_intro": "Selecione os artigos e indique o que pretende fazer com cada um. Pode tratar em conjunto o que já foi enviado e o que ainda está por enviar.",
    "pick_action": "O que pretende fazer com este artigo?",
    "pick_action_single": "Ação:",
    "act_cancel_short": "Cancelar",
    "act_return_short": "Devolver",
    "act_exchange_short": "Trocar",
    "act_refuse_short": "Recusar entrega",
    "item_no_actions": "Sem ações disponíveis para este artigo.",
    "no_actions_title": "Sem ações disponíveis online",
    "select_all": "Selecionar todos os artigos",
    "exch_also_title": "Este pedido inclui também:",
    "existing_title": "Já existe um pedido para esta encomenda",
    "existing_msg": "Para qualquer alteração, contacte o apoio ao cliente por email ou telefone.",
    "existing_ref": "Referência:",
    "existing_date": "Submetido a",
    "existing_status": "Estado:",
    "existing_items_title": "Artigos do pedido:",
    "existing_generic": "Em análise",
    "reqtype_return": "Devolução",
    "reqtype_exchange": "Troca",
    "reqtype_cancellation": "Cancelamento",
    "reqtype_withdrawal": "Resolução / Recusa de entrega",
    "reqtype_mixed": "Pedido misto"
  },
  "es": {
    "grp_delivered_on": "Entregado el",
    "grp_window_expired": "Plazo de devolución vencido",
    "c_title": "Devoluciones, Cambios y Cancelaciones",
    "c_intro": "Solicite su devolución, cambio o cancelación de forma sencilla en el formulario de abajo.",
    "c_conditions": "<p>El proceso de cambio o devolución es sencillo. Tiene hasta 14 días después de recibir el pedido para comunicarnos su intención de cambio o devolución a través de este formulario. En caso de cancelación, esta solo se acepta antes del envío del pedido o del inicio de la personalización de los artículos.</p><p>Tras enviar la solicitud, deberá hacernos llegar el/los artículo(s) a la dirección indicada o, cuando proceda, optar por el servicio de recogida disponible en el formulario. La solicitud solo se analizará tras la recepción y validación de los artículos devueltos.</p><p>Los artículos deben encontrarse en estado original, sin señales de uso, lavado, olores, daños o alteraciones y, siempre que proceda, con etiquetas, embalajes y cajas originales.</p><p>Para garantizar el correcto procesamiento de la solicitud, le pedimos que tenga en cuenta:</p><ul><li>Indique el número de pedido en el envío, en la caja o con una nota en el interior;</li><li>Embale los artículos en una caja o sobre cerrado, de forma segura;</li><li>En el caso del calzado, la caja original debe protegerse con un embalaje exterior y no debe utilizarse directamente como caja de envío;</li><li>Los cambios se procesan habitualmente en un plazo de hasta 5 días hábiles tras la recepción y validación de los artículos devueltos;</li><li>En caso de cambio, cuando se realice el nuevo envío, le enviaremos un correo electrónico con el número de seguimiento correspondiente;</li><li>Los reembolsos se procesan habitualmente entre 5 y 8 días hábiles tras la validación de la devolución.</li><li>Por favor, no envíe pedidos antes de rellenar el formulario</li></ul><p>En caso de reembolso, si el pago se realizó con tarjeta, PayPal, Klarna o MB Way, el importe se reembolsará por la misma vía. Si el pago se realizó por Multibanco, transferencia bancaria o Payshop, será necesario indicar el IBAN y el nombre del titular de la cuenta.</p>",
    "c_ineligible": "No se realizan cambios, devoluciones ni cancelaciones de artículos personalizados (con texto o bordados) ni íntimos.",
    "c_intransit": "<p>Su pedido ya ha sido enviado pero aún no ha sido entregado. En esta fase no es posible iniciar cambios o devoluciones por el formulario. Puede <strong>rechazar la entrega</strong>; el reembolso o el cambio solo se procesarán tras la llegada del pedido devuelto.</p>",
    "paid_badge": "Pagado",
    "remove": "Quitar",
    "sending": "Enviando…",
    "iban_ph": "PT50 0000 0000 0000 0000 0000 0",
    "holder_ph": "Nombre completo",
    "required_mark": "*",
    "step_order": "1 · Pedido",
    "step_items": "2 · Artículos",
    "step_exchange": "3 · Cambio",
    "order_number_label": "Número del pedido",
    "order_number_ph": "Ej: 1001",
    "email_label": "Email del pedido",
    "email_ph": "tu@email.com",
    "help_prefix": "¿No sabe el número del pedido? Lo encuentra en el",
    "help_email_word": "email de confirmación",
    "help_received": "que recibió, o",
    "help_account": "en su cuenta.",
    "help_login": "iniciando sesión en su cuenta.",
    "search_btn": "Buscar pedido",
    "searching": "Buscando…",
    "conditions_title": "Condiciones de cambio y devolución",
    "address_label": "Dirección de envío:",
    "pickup_inline_label": "Recogida a domicilio",
    "pickup_inline_text": "podemos programar la recogida del artículo, debidamente embalado.",
    "pickup_link": "Enlace para la recogida de artículos",
    "policy_link": "Ver la política completa de cambios y devoluciones",
    "summary_order": "Pedido:",
    "summary_email": "Email:",
    "summary_payment": "Pago:",
    "summary_shipping": "Envío:",
    "within_yes": "Dentro de los 14 días",
    "within_no": "Fuera del plazo de 14 días",
    "delivery_unfulfilled": "Por enviar",
    "delivery_label_printed": "En preparación",
    "delivery_in_transit": "En tránsito",
    "delivery_out_for_delivery": "En reparto",
    "delivery_delivered": "Entregado",
    "delivery_fulfilled": "Enviado",
    "actions_title": "¿Qué desea hacer?",
    "action_cancel_t": "Cancelar pedido",
    "action_cancel_d": "El pedido aún no se ha enviado.",
    "action_withdrawal_t": "Resolver / Cancelar",
    "action_withdrawal_d": "Desistimiento — rechazar la entrega.",
    "action_return_t": "Devolver",
    "action_return_d": "Reembolso tras recepción y evaluación.",
    "action_exchange_t": "Cambiar",
    "action_exchange_d_pre": "Cambiar artículo/talla antes del envío.",
    "action_exchange_d": "Cambiar por otro(s) artículo(s).",
    "no_actions": "Este pedido no reúne las condiciones para cambio, devolución o cancelación (fuera del plazo de 14 días o ya enviado). En caso de duda, contáctenos.",
    "items_title": "Seleccione los artículos",
    "qty_ordered": "Cant. pedida:",
    "qty": "Cant.",
    "ineligible_fallback": "Artículo no elegible",
    "shipping_title": "¿Cómo nos hará llegar el/los artículo(s)?",
    "ship_self": "Envío por su cuenta",
    "ship_self_desc": "Envíe por correo certificado a la dirección indicada.",
    "ship_pickup": "Recogida a domicilio",
    "ship_pickup_desc": "Programamos la recogida por mensajería.",
    "pickup_country_only": "Disponible solo para entregas en Portugal o España.",
    "refund_title": "Reembolso",
    "refund_original": "Forma de pago original",
    "refund_original_desc": "Tarjeta, MB Way, PayPal o Klarna — sin datos adicionales.",
    "refund_original_desc_ok": "Reembolso a la misma forma de pago utilizada (tarjeta, MB Way, PayPal o Klarna).",
    "refund_original_desc_iban": "Solo válida para tarjeta, MB Way, PayPal o Klarna.",
    "refund_iban": "Transferencia bancaria (IBAN)",
    "refund_iban_desc": "Necesario si el pago no permite reembolso directo.",
    "refund_iban_desc_disabled": "No disponible — el reembolso se hace a la forma de pago original.",
    "refund_iban_desc_required": "Obligatoria para Multibanco, transferencia bancaria o Payshop.",
    "iban_label": "IBAN",
    "iban_holder_label": "Nombre del titular",
    "notes_label": "Observaciones (opcional)",
    "notes_ph": "Ej: motivo de la devolución, indicaciones…",
    "back": "Volver",
    "submit_order": "Enviar solicitud",
    "submit_withdrawal": "Enviar desistimiento",
    "continue_exchange": "Continuar al cambio",
    "ex_recap_return": "Artículos a devolver",
    "ex_recap_swap": "Artículos a cambiar",
    "ex_mode_title": "¿Qué desea a cambio?",
    "ex_mode_variant": "Mismo artículo, otro color/talla",
    "ex_mode_variant_desc": "Elija la nueva variante de cada artículo.",
    "ex_mode_different": "Un artículo diferente",
    "ex_mode_different_desc": "Importe del carrito los artículos deseados.",
    "ex_loading": "Cargando opciones de cambio…",
    "ex_swap_title": "Cambiar por (color / talla):",
    "ex_no_handle": "Para cambiar este artículo, use «Importar del carrito» abajo.",
    "ex_no_variants": "Este artículo no tiene otras variantes. Para cambiar por otro artículo, use «Importar del carrito».",
    "ex_status_unavailable": "Combinación no disponible.",
    "ex_status_sold_out": "Agotado en esta variante.",
    "ex_status_choose_diff": "Elija un color o talla diferente del actual.",
    "ex_status_new": "✓ Nuevo:",
    "ex_cart_hint": "Añada al carrito de la tienda los artículos deseados y haga clic en «Importar del carrito». Puede ajustar cantidades o quitar abajo.",
    "ex_cart_empty_note": "Añada al carrito de la tienda los artículos deseados y haga clic en «Importar del carrito».",
    "ex_import_btn": "🛒 Importar del carrito",
    "ex_cart_empty_err": "Su carrito está vacío. Añada los artículos deseados en la tienda e importe de nuevo.",
    "ex_cart_error": "Error al importar el carrito.",
    "ex_submit": "Enviar cambio",
    "pickup_cost_label": "Coste de la recogida:",
    "pickup_processed": "(procesado por la tienda online)",
    "pickup_buy": "Comprar recogida",
    "success_title": "Solicitud enviada correctamente",
    "success_msg": "Hemos recibido su solicitud y enviado un email de confirmación con todas las instrucciones y los próximos pasos.",
    "success_ref": "Referencia de la solicitud:",
    "err_not_found": "Pedido no encontrado o email incorrecto.",
    "err_comm": "Error de comunicación. Inténtelo de nuevo.",
    "err_submit": "No se pudo enviar la solicitud. Inténtelo de nuevo.",
    "err_iban_required": "Indique el IBAN y el nombre del titular para el reembolso.",
    "intransit_title": "Pedido en camino — aún no entregado",
    "pickup_country_note": "*Válido solo para Portugal y España peninsular",
    "l_order": "Pedido:",
    "l_email": "Email:",
    "l_payment": "Pago:",
    "l_shipping": "Envío:",
    "badge_paid": "Pagado",
    "within14": "Dentro de los 14 días",
    "outside14": "Fuera del plazo de 14 días",
    "del_unfulfilled": "Por enviar",
    "del_label_printed": "En preparación",
    "del_in_transit": "En tránsito",
    "del_out_for_delivery": "En reparto",
    "del_delivered": "Entregado",
    "del_fulfilled": "Enviado",
    "act_cancel_t": "Cancelar pedido",
    "act_cancel_d": "El pedido aún no se ha enviado.",
    "act_withdraw_t": "Resolver / Cancelar",
    "act_withdraw_d": "Desistimiento — rechazar la entrega.",
    "act_return_t": "Devolver",
    "act_return_d": "Reembolso tras recepción y evaluación.",
    "act_exchange_t": "Cambiar",
    "act_exchange_d": "Cambiar por otro(s) artículo(s).",
    "act_exchange_d_pre": "Cambiar artículo/talla antes del envío.",
    "item_ineligible": "Artículo no elegible",
    "rf_orig_original": "Reembolso a la misma forma de pago utilizada (tarjeta, MB Way, PayPal o Klarna).",
    "rf_iban_unavailable": "No disponible — el reembolso se hace a la forma de pago original.",
    "rf_orig_ibanonly": "Solo válida para tarjeta, MB Way, PayPal o Klarna.",
    "rf_iban_required": "Obligatoria para Multibanco, transferencia bancaria o Payshop.",
    "rf_orig_unknown": "Tarjeta, MB Way, PayPal o Klarna — sin datos adicionales.",
    "rf_iban_unknown": "Necesario si el pago no permite reembolso directo.",
    "continue_withdrawal": "Enviar desistimiento",
    "continue_submit": "Enviar solicitud",
    "exch_recap_return": "Artículos a devolver",
    "exch_recap_predispatch": "Artículos a cambiar",
    "vs_loading": "Cargando opciones de cambio…",
    "vs_title": "Cambiar por (color / talla):",
    "vs_fallback_cart": "Para cambiar este artículo, use «Importar del carrito» abajo.",
    "vs_no_variants": "Este artículo no tiene otras variantes. Para cambiar por otro artículo, use «Importar del carrito».",
    "vs_unavailable": "Combinación no disponible.",
    "vs_soldout": "Agotado en esta variante.",
    "vs_choosediff": "Elija un color o talla diferente del actual.",
    "vs_new": "✓ Nuevo:",
    "exch_cart_empty": "Añada al carrito de la tienda los artículos deseados y haga clic en «Importar del carrito».",
    "exch_cart_empty_err": "Su carrito está vacío. Añada los artículos deseados en la tienda e importe de nuevo.",
    "exch_cart_error": "Error al importar el carrito.",
    "success_ref_label": "Referencia de la solicitud:",
    "pickup_deduct_pre": "Se descontarán",
    "pickup_deduct_post": "del importe a reembolsar.",
    "pickup_buy_pre": "La recogida tiene un coste de",
    "pickup_buy_post": ". En la pantalla final, tras confirmar la solicitud, se mostrará el enlace para comprar el artículo de recogida.",
    "pickup_same_addr_q": "¿La dirección de recogida es la misma que la de entrega?",
    "pickup_same_yes": "Sí, es la misma",
    "pickup_same_no": "No, indicar otra",
    "pickup_addr_name": "Nombre de contacto",
    "pickup_addr_name_ph": "Quien entrega el paquete a los CTT",
    "pickup_addr_phone": "Teléfono",
    "pickup_addr_phone_ph": "Para contacto de los CTT",
    "pickup_addr_line": "Dirección",
    "pickup_addr_line_ph": "Calle, número, piso",
    "pickup_addr_postal": "Código postal",
    "pickup_addr_postal_ph": "0000-000",
    "pickup_addr_city": "Localidad",
    "pickup_addr_city_ph": "Localidad",
    "pickup_day_label": "¿Cuál es el mejor día para la recogida?",
    "pickup_day_ph": "Ejemplos: Día 20 de enero, martes y jueves",
    "pickup_note_title": "Importante:",
    "pickup_note_body": "Las recogidas se realizan a través de CTT en días laborables y en horario laboral, no siendo posible programar una hora. Los artículos deben estar bien embalados en una caja o sobre cerrado para permitir un envío seguro. Esto también se aplica a las cajas de calzado, que deberán embalarse de forma que queden protegidas.",
    "err_pickup_addr_required": "Indique la dirección de recogida (dirección, código postal y localidad).",
    "err_required_fields": "Complete los campos obligatorios marcados en rojo.",
    "ex_balance_title": "Ajuste de importes",
    "ex_balance_intro_refund": "De su solicitud de cambio resulta un importe a su favor, que le será reembolsado:",
    "ex_balance_intro_pay": "De su solicitud de cambio resulta un importe a pagar:",
    "ex_balance_intro_even": "De su cambio no resulta ningún importe que ajustar.",
    "ex_balance_returned": "Devuelto",
    "ex_balance_new": "Nuevo(s)",
    "ex_balance_refund": "a reembolsar",
    "ex_balance_pay": "a pagar",
    "ex_balance_even": "Sin importe que ajustar.",
    "ex_topay_note": "Hay un importe a pagar por la diferencia. Se comunicará posteriormente por nuestro equipo, con las instrucciones de pago.",
    "success_pickup_title": "Falta programar la recogida",
    "success_pickup_msg": "Para completar la programación de la recogida, finalice la compra a continuación. La recogida solo se programa tras el pago.",
    "badge_partial": "Parcial",
    "grp_unfulfilled": "Por enviar",
    "grp_in_transit": "En camino",
    "grp_delivered": "Entregado",
    "grp_tracking": "Seguimiento:",
    "choose_intro": "Seleccione los artículos e indique qué desea hacer con cada uno. Puede gestionar a la vez lo ya enviado y lo que aún está por enviar.",
    "pick_action": "¿Qué desea hacer con este artículo?",
    "pick_action_single": "Acción:",
    "act_cancel_short": "Cancelar",
    "act_return_short": "Devolver",
    "act_exchange_short": "Cambiar",
    "act_refuse_short": "Rechazar entrega",
    "item_no_actions": "Sin acciones disponibles para este artículo.",
    "no_actions_title": "Sin acciones disponibles online",
    "select_all": "Seleccionar todos los artículos",
    "exch_also_title": "Esta solicitud también incluye:",
    "existing_title": "Ya existe una solicitud para este pedido",
    "existing_msg": "Para cualquier cambio, contacte con atención al cliente por email o teléfono.",
    "existing_ref": "Referencia:",
    "existing_date": "Enviado el",
    "existing_status": "Estado:",
    "existing_items_title": "Artículos de la solicitud:",
    "existing_generic": "En análisis",
    "reqtype_return": "Devolución",
    "reqtype_exchange": "Cambio",
    "reqtype_cancellation": "Cancelación",
    "reqtype_withdrawal": "Desistimiento / Rechazo",
    "reqtype_mixed": "Solicitud mixta"
  },
  "en": {
    "grp_delivered_on": "Delivered on",
    "grp_window_expired": "Return period expired",
    "c_title": "Returns, Exchanges & Cancellations",
    "c_intro": "Request your return, exchange or cancellation easily in the form below.",
    "c_conditions": "<p>The exchange or return process is simple. You have up to 14 days after receiving the order to let us know your intention to exchange or return through this form. Cancellations are only accepted before the order is dispatched or before personalisation of the items begins.</p><p>After submitting your request, you must send the item(s) to the address provided or, where applicable, choose the collection service available in the form. The request will only be reviewed after the returned items have been received and validated.</p><p>Items must be in original condition, with no signs of use, washing, odours, damage or alterations, and, where applicable, with their original tags, packaging and boxes.</p><p>To ensure your request is processed correctly, please note:</p><ul><li>State the order number on the shipment, on the box, or with a note inside;</li><li>Pack the items securely in a sealed box or envelope;</li><li>For footwear, the original box must be protected with outer packaging and must not be used directly as the shipping box;</li><li>Exchanges are usually processed within 5 business days after the returned items are received and validated;</li><li>In the case of an exchange, once the new shipment is dispatched, we will send an email with the corresponding tracking number;</li><li>Refunds are usually processed within 5 to 8 business days after the return is validated.</li><li>Please do not send any parcels before completing the form</li></ul><p>In the case of a refund, if payment was made by card, PayPal, Klarna or MB Way, the amount will be refunded via the same method. If payment was made by Multibanco, bank transfer or Payshop, you will need to provide the IBAN and the account holder's name.</p>",
    "c_ineligible": "Personalised items (with text or embroidery) and intimate items cannot be exchanged, returned or cancelled.",
    "c_intransit": "<p>Your order has already shipped but hasn't been delivered yet. At this stage you can't start exchanges or returns through the form. You may <strong>refuse the delivery</strong>; the refund or exchange will only be processed after the returned order arrives.</p>",
    "paid_badge": "Paid",
    "remove": "Remove",
    "sending": "Sending…",
    "iban_ph": "PT50 0000 0000 0000 0000 0000 0",
    "holder_ph": "Full name",
    "required_mark": "*",
    "step_order": "1 · Order",
    "step_items": "2 · Items",
    "step_exchange": "3 · Exchange",
    "order_number_label": "Order number",
    "order_number_ph": "e.g. 1001",
    "email_label": "Order email",
    "email_ph": "you@email.com",
    "help_prefix": "Don't know your order number? Find it in the",
    "help_email_word": "confirmation email",
    "help_received": "you received, or",
    "help_account": "in your account.",
    "help_login": "by logging in to your account.",
    "search_btn": "Find order",
    "searching": "Searching…",
    "conditions_title": "Returns & exchanges conditions",
    "address_label": "Return address:",
    "pickup_inline_label": "Local pickup",
    "pickup_inline_text": "we can arrange pickup of the item, properly packaged.",
    "pickup_link": "Link to item pickup",
    "policy_link": "See the full returns & exchanges policy",
    "summary_order": "Order:",
    "summary_email": "Email:",
    "summary_payment": "Payment:",
    "summary_shipping": "Shipping:",
    "within_yes": "Within 14 days",
    "within_no": "Outside the 14-day window",
    "delivery_unfulfilled": "Not shipped",
    "delivery_label_printed": "Preparing shipment",
    "delivery_in_transit": "In transit",
    "delivery_out_for_delivery": "Out for delivery",
    "delivery_delivered": "Delivered",
    "delivery_fulfilled": "Shipped",
    "actions_title": "What would you like to do?",
    "action_cancel_t": "Cancel order",
    "action_cancel_d": "The order hasn't shipped yet.",
    "action_withdrawal_t": "Withdraw / Cancel",
    "action_withdrawal_d": "Right of withdrawal — refuse the delivery.",
    "action_return_t": "Return",
    "action_return_d": "Refund after receipt and inspection.",
    "action_exchange_t": "Exchange",
    "action_exchange_d_pre": "Change item/size before dispatch.",
    "action_exchange_d": "Exchange for other item(s).",
    "no_actions": "This order doesn't meet the conditions for an exchange, return or cancellation (outside the 14-day window or already shipped). If in doubt, contact us.",
    "items_title": "Select the items",
    "qty_ordered": "Qty ordered:",
    "qty": "Qty",
    "ineligible_fallback": "Item not eligible",
    "shipping_title": "How will you send the item(s)?",
    "ship_self": "Send it yourself",
    "ship_self_desc": "Send by registered mail to the address shown.",
    "ship_pickup": "Local pickup",
    "ship_pickup_desc": "We arrange pickup via the courier.",
    "pickup_country_only": "Available only for deliveries in Portugal or Spain.",
    "refund_title": "Refund",
    "refund_original": "Original payment method",
    "refund_original_desc": "Card, MB Way, PayPal or Klarna — no extra details.",
    "refund_original_desc_ok": "Refund to the same payment method used (card, MB Way, PayPal or Klarna).",
    "refund_original_desc_iban": "Only valid for card, MB Way, PayPal or Klarna.",
    "refund_iban": "Bank transfer (IBAN)",
    "refund_iban_desc": "Needed if the payment can't be refunded directly.",
    "refund_iban_desc_disabled": "Unavailable — the refund is issued to the original payment method.",
    "refund_iban_desc_required": "Required for Multibanco, bank transfer or Payshop.",
    "iban_label": "IBAN",
    "iban_holder_label": "Account holder name",
    "notes_label": "Notes (optional)",
    "notes_ph": "e.g. reason for return, instructions…",
    "back": "Back",
    "submit_order": "Submit request",
    "submit_withdrawal": "Submit withdrawal",
    "continue_exchange": "Continue to exchange",
    "ex_recap_return": "Items to return",
    "ex_recap_swap": "Items to exchange",
    "ex_mode_title": "What would you like in exchange?",
    "ex_mode_variant": "Same item, different colour/size",
    "ex_mode_variant_desc": "Choose the new variant for each item.",
    "ex_mode_different": "A different item",
    "ex_mode_different_desc": "Import the desired items from the cart.",
    "ex_loading": "Loading exchange options…",
    "ex_swap_title": "Exchange for (colour / size):",
    "ex_no_handle": "To exchange this item, use “Import from cart” below.",
    "ex_no_variants": "This item has no other variants. To exchange for a different item, use “Import from cart”.",
    "ex_status_unavailable": "Combination unavailable.",
    "ex_status_sold_out": "Sold out in this variant.",
    "ex_status_choose_diff": "Choose a colour or size different from the current one.",
    "ex_status_new": "✓ New:",
    "ex_cart_hint": "Add the desired items to the store cart and click “Import from cart”. You can adjust quantities or remove below.",
    "ex_cart_empty_note": "Add the desired items to the store cart and click “Import from cart”.",
    "ex_import_btn": "🛒 Import from cart",
    "ex_cart_empty_err": "Your cart is empty. Add the desired items in the store and import again.",
    "ex_cart_error": "Error importing the cart.",
    "ex_submit": "Submit exchange",
    "pickup_cost_label": "Pickup cost:",
    "pickup_processed": "(charged via the online store)",
    "pickup_buy": "Buy pickup",
    "success_title": "Request submitted successfully",
    "success_msg": "We've received your request and sent a confirmation email with all the instructions and next steps.",
    "success_ref": "Request reference:",
    "err_not_found": "Order not found or incorrect email.",
    "err_comm": "Communication error. Please try again.",
    "err_submit": "Could not submit the request. Please try again.",
    "err_iban_required": "Enter the IBAN and account holder name for the refund.",
    "intransit_title": "Order on its way — not delivered yet",
    "pickup_country_note": "*Valid only for mainland Portugal and Spain",
    "l_order": "Order:",
    "l_email": "Email:",
    "l_payment": "Payment:",
    "l_shipping": "Shipping:",
    "badge_paid": "Paid",
    "within14": "Within 14 days",
    "outside14": "Outside the 14-day window",
    "del_unfulfilled": "Not shipped",
    "del_label_printed": "Preparing shipment",
    "del_in_transit": "In transit",
    "del_out_for_delivery": "Out for delivery",
    "del_delivered": "Delivered",
    "del_fulfilled": "Shipped",
    "act_cancel_t": "Cancel order",
    "act_cancel_d": "The order hasn't shipped yet.",
    "act_withdraw_t": "Withdraw / Cancel",
    "act_withdraw_d": "Right of withdrawal — refuse the delivery.",
    "act_return_t": "Return",
    "act_return_d": "Refund after receipt and inspection.",
    "act_exchange_t": "Exchange",
    "act_exchange_d": "Exchange for other item(s).",
    "act_exchange_d_pre": "Change item/size before dispatch.",
    "item_ineligible": "Item not eligible",
    "rf_orig_original": "Refund to the same payment method used (card, MB Way, PayPal or Klarna).",
    "rf_iban_unavailable": "Unavailable — the refund is issued to the original payment method.",
    "rf_orig_ibanonly": "Only valid for card, MB Way, PayPal or Klarna.",
    "rf_iban_required": "Required for Multibanco, bank transfer or Payshop.",
    "rf_orig_unknown": "Card, MB Way, PayPal or Klarna — no extra details.",
    "rf_iban_unknown": "Needed if the payment can't be refunded directly.",
    "continue_withdrawal": "Submit withdrawal",
    "continue_submit": "Submit request",
    "exch_recap_return": "Items to return",
    "exch_recap_predispatch": "Items to exchange",
    "vs_loading": "Loading exchange options…",
    "vs_title": "Exchange for (colour / size):",
    "vs_fallback_cart": "To exchange this item, use “Import from cart” below.",
    "vs_no_variants": "This item has no other variants. To exchange for a different item, use “Import from cart”.",
    "vs_unavailable": "Combination unavailable.",
    "vs_soldout": "Sold out in this variant.",
    "vs_choosediff": "Choose a colour or size different from the current one.",
    "vs_new": "✓ New:",
    "exch_cart_empty": "Add the desired items to the store cart and click “Import from cart”.",
    "exch_cart_empty_err": "Your cart is empty. Add the desired items in the store and import again.",
    "exch_cart_error": "Error importing the cart.",
    "success_ref_label": "Request reference:",
    "pickup_deduct_pre": "We'll deduct",
    "pickup_deduct_post": "from the amount to be refunded.",
    "pickup_buy_pre": "The pickup costs",
    "pickup_buy_post": ". On the final screen, after you confirm the request, you'll get the link to buy the pickup item.",
    "pickup_same_addr_q": "Is the pickup address the same as the delivery address?",
    "pickup_same_yes": "Yes, it's the same",
    "pickup_same_no": "No, use another",
    "pickup_addr_name": "Contact name",
    "pickup_addr_name_ph": "Who hands the parcel to the courier",
    "pickup_addr_phone": "Phone",
    "pickup_addr_phone_ph": "For the courier to contact",
    "pickup_addr_line": "Address",
    "pickup_addr_line_ph": "Street, number, floor",
    "pickup_addr_postal": "Postal code",
    "pickup_addr_postal_ph": "0000-000",
    "pickup_addr_city": "City",
    "pickup_addr_city_ph": "City",
    "pickup_day_label": "What's the best day for the pickup?",
    "pickup_day_ph": "Examples: January 20th, Tuesdays and Thursdays",
    "pickup_note_title": "Important:",
    "pickup_note_body": "Pickups are carried out via CTT on business days during working hours; a specific time cannot be scheduled. Items must be well packed in a closed box or envelope to allow safe shipping. This also applies to shoe boxes, which must be packed so they are protected.",
    "err_pickup_addr_required": "Please provide the pickup address (address, postal code and city).",
    "err_required_fields": "Please fill in the required fields highlighted in red.",
    "ex_balance_title": "Balance adjustment",
    "ex_balance_intro_refund": "Your exchange results in an amount in your favour, which will be refunded to you:",
    "ex_balance_intro_pay": "Your exchange results in an amount to pay:",
    "ex_balance_intro_even": "Your exchange has no balance to settle.",
    "ex_balance_returned": "Returned",
    "ex_balance_new": "New item(s)",
    "ex_balance_refund": "to refund",
    "ex_balance_pay": "to pay",
    "ex_balance_even": "Nothing to settle.",
    "ex_topay_note": "There's an amount to pay for the difference. Our team will contact you afterwards with the payment instructions.",
    "success_pickup_title": "Pickup still needs to be scheduled",
    "success_pickup_msg": "To complete the pickup scheduling, finish the purchase below. The pickup is only scheduled after payment.",
    "badge_partial": "Partial",
    "grp_unfulfilled": "Not shipped",
    "grp_in_transit": "On the way",
    "grp_delivered": "Delivered",
    "grp_tracking": "Tracking:",
    "choose_intro": "Select the items and choose what to do with each one. You can handle what's already shipped and what's still to ship together.",
    "pick_action": "What would you like to do with this item?",
    "pick_action_single": "Action:",
    "act_cancel_short": "Cancel",
    "act_return_short": "Return",
    "act_exchange_short": "Exchange",
    "act_refuse_short": "Refuse delivery",
    "item_no_actions": "No actions available for this item.",
    "no_actions_title": "No online actions available",
    "select_all": "Select all items",
    "exch_also_title": "This request also includes:",
    "existing_title": "There's already a request for this order",
    "existing_msg": "For any change, please contact customer support by email or phone.",
    "existing_ref": "Reference:",
    "existing_date": "Submitted on",
    "existing_status": "Status:",
    "existing_items_title": "Items in the request:",
    "existing_generic": "Under review",
    "reqtype_return": "Return",
    "reqtype_exchange": "Exchange",
    "reqtype_cancellation": "Cancellation",
    "reqtype_withdrawal": "Withdrawal / Refusal",
    "reqtype_mixed": "Mixed request"
  },
  "fr": {
    "grp_delivered_on": "Livré le",
    "grp_window_expired": "Délai de retour expiré",
    "c_title": "Retours, Échanges et Annulations",
    "c_intro": "Demandez votre retour, échange ou annulation simplement dans le formulaire ci-dessous.",
    "c_conditions": "<p>Le processus d'échange ou de retour est simple. Vous disposez de 14 jours après la réception de la commande pour nous communiquer votre intention d'échange ou de retour via ce formulaire. En cas d'annulation, celle-ci n'est acceptée qu'avant l'expédition de la commande ou avant le début de la personnalisation des articles.</p><p>Après avoir soumis votre demande, vous devrez nous faire parvenir le(s) article(s) à l'adresse indiquée ou, le cas échéant, opter pour le service de collecte disponible dans le formulaire. La demande ne sera analysée qu'après la réception et la validation des articles retournés.</p><p>Les articles doivent être en état d'origine, sans signe d'utilisation, de lavage, d'odeurs, de dommages ou de modifications et, le cas échéant, avec leurs étiquettes, emballages et boîtes d'origine.</p><p>Afin de garantir le bon traitement de votre demande, nous vous prions de tenir compte des points suivants :</p><ul><li>Indiquez le numéro de commande sur l'envoi, sur la boîte ou à l'aide d'une note à l'intérieur ;</li><li>Emballez les articles de manière sûre dans une boîte ou une enveloppe fermée ;</li><li>Pour les chaussures, la boîte d'origine doit être protégée par un emballage extérieur et ne doit pas être utilisée directement comme boîte d'expédition ;</li><li>Les échanges sont habituellement traités dans un délai de 5 jours ouvrables après la réception et la validation des articles retournés ;</li><li>En cas d'échange, lorsque la nouvelle expédition est effectuée, nous vous enverrons un e-mail avec le numéro de suivi correspondant ;</li><li>Les remboursements sont habituellement traités sous 5 à 8 jours ouvrables après la validation du retour.</li><li>Veuillez ne pas envoyer de colis avant d'avoir rempli le formulaire</li></ul><p>En cas de remboursement, si le paiement a été effectué par carte, PayPal, Klarna ou MB Way, le montant sera remboursé par le même moyen. Si le paiement a été effectué par Multibanco, virement bancaire ou Payshop, il sera nécessaire d'indiquer l'IBAN et le nom du titulaire du compte.</p>",
    "c_ineligible": "Les articles personnalisés (avec texte ou broderie) et les articles intimes ne peuvent être ni échangés, ni retournés, ni annulés.",
    "c_intransit": "<p>Votre commande a déjà été expédiée mais n'a pas encore été livrée. À ce stade, vous ne pouvez pas démarrer d'échange ou de retour via le formulaire. Vous pouvez <strong>refuser la livraison</strong> ; le remboursement ou l'échange ne sera traité qu'après le retour de la commande.</p>",
    "paid_badge": "Payé",
    "remove": "Retirer",
    "sending": "Envoi…",
    "iban_ph": "PT50 0000 0000 0000 0000 0000 0",
    "holder_ph": "Nom complet",
    "required_mark": "*",
    "step_order": "1 · Commande",
    "step_items": "2 · Articles",
    "step_exchange": "3 · Échange",
    "order_number_label": "Numéro de commande",
    "order_number_ph": "Ex : 1001",
    "email_label": "E-mail de la commande",
    "email_ph": "vous@email.com",
    "help_prefix": "Vous ne connaissez pas le numéro de commande ? Vous le trouverez dans l'",
    "help_email_word": "e-mail de confirmation",
    "help_received": "que vous avez reçu, ou",
    "help_account": "dans votre compte.",
    "help_login": "en vous connectant à votre compte.",
    "search_btn": "Rechercher la commande",
    "searching": "Recherche…",
    "conditions_title": "Conditions d'échange et de retour",
    "address_label": "Adresse d'envoi :",
    "pickup_inline_label": "Enlèvement à domicile",
    "pickup_inline_text": "nous pouvons planifier l'enlèvement de l'article, correctement emballé.",
    "pickup_link": "Lien pour l'enlèvement des articles",
    "policy_link": "Voir la politique complète de retours et d'échanges",
    "summary_order": "Commande :",
    "summary_email": "E-mail :",
    "summary_payment": "Paiement :",
    "summary_shipping": "Expédition :",
    "within_yes": "Dans les 14 jours",
    "within_no": "Hors du délai de 14 jours",
    "delivery_unfulfilled": "À expédier",
    "delivery_label_printed": "En préparation",
    "delivery_in_transit": "En transit",
    "delivery_out_for_delivery": "En cours de livraison",
    "delivery_delivered": "Livré",
    "delivery_fulfilled": "Expédié",
    "actions_title": "Que souhaitez-vous faire ?",
    "action_cancel_t": "Annuler la commande",
    "action_cancel_d": "La commande n'a pas encore été expédiée.",
    "action_withdrawal_t": "Résilier / Annuler",
    "action_withdrawal_d": "Droit de rétractation — refuser la livraison.",
    "action_return_t": "Retourner",
    "action_return_d": "Remboursement après réception et évaluation.",
    "action_exchange_t": "Échanger",
    "action_exchange_d_pre": "Changer d'article/taille avant l'expédition.",
    "action_exchange_d": "Échanger contre d'autre(s) article(s).",
    "no_actions": "Cette commande ne remplit pas les conditions d'échange, de retour ou d'annulation (hors délai de 14 jours ou déjà expédiée). En cas de doute, contactez-nous.",
    "items_title": "Sélectionnez les articles",
    "qty_ordered": "Qté commandée :",
    "qty": "Qté",
    "ineligible_fallback": "Article non éligible",
    "shipping_title": "Comment nous faites-vous parvenir le(s) article(s) ?",
    "ship_self": "Envoi par vos soins",
    "ship_self_desc": "Envoyez en recommandé à l'adresse indiquée.",
    "ship_pickup": "Enlèvement à domicile",
    "ship_pickup_desc": "Nous planifions l'enlèvement par le transporteur.",
    "pickup_country_only": "Disponible uniquement pour les livraisons au Portugal ou en Espagne.",
    "refund_title": "Remboursement",
    "refund_original": "Mode de paiement d'origine",
    "refund_original_desc": "Carte, MB Way, PayPal ou Klarna — sans données supplémentaires.",
    "refund_original_desc_ok": "Remboursement sur le mode de paiement utilisé (carte, MB Way, PayPal ou Klarna).",
    "refund_original_desc_iban": "Valable uniquement pour carte, MB Way, PayPal ou Klarna.",
    "refund_iban": "Virement bancaire (IBAN)",
    "refund_iban_desc": "Nécessaire si le paiement ne peut pas être remboursé directement.",
    "refund_iban_desc_disabled": "Indisponible — le remboursement est effectué sur le mode de paiement d'origine.",
    "refund_iban_desc_required": "Obligatoire pour Multibanco, virement bancaire ou Payshop.",
    "iban_label": "IBAN",
    "iban_holder_label": "Nom du titulaire",
    "notes_label": "Remarques (facultatif)",
    "notes_ph": "Ex : motif du retour, indications…",
    "back": "Retour",
    "submit_order": "Envoyer la demande",
    "submit_withdrawal": "Envoyer la rétractation",
    "continue_exchange": "Continuer vers l'échange",
    "ex_recap_return": "Articles à retourner",
    "ex_recap_swap": "Articles à échanger",
    "ex_mode_title": "Que souhaitez-vous en échange ?",
    "ex_mode_variant": "Même article, autre couleur/taille",
    "ex_mode_variant_desc": "Choisissez la nouvelle variante de chaque article.",
    "ex_mode_different": "Un article différent",
    "ex_mode_different_desc": "Importez du panier les articles souhaités.",
    "ex_loading": "Chargement des options d'échange…",
    "ex_swap_title": "Échanger contre (couleur / taille) :",
    "ex_no_handle": "Pour échanger cet article, utilisez « Importer du panier » ci-dessous.",
    "ex_no_variants": "Cet article n'a pas d'autres variantes. Pour échanger contre un autre article, utilisez « Importer du panier ».",
    "ex_status_unavailable": "Combinaison indisponible.",
    "ex_status_sold_out": "Épuisé dans cette variante.",
    "ex_status_choose_diff": "Choisissez une couleur ou une taille différente de l'actuelle.",
    "ex_status_new": "✓ Nouveau :",
    "ex_cart_hint": "Ajoutez au panier de la boutique les articles souhaités et cliquez sur « Importer du panier ». Vous pouvez ajuster les quantités ou supprimer ci-dessous.",
    "ex_cart_empty_note": "Ajoutez au panier de la boutique les articles souhaités et cliquez sur « Importer du panier ».",
    "ex_import_btn": "🛒 Importer du panier",
    "ex_cart_empty_err": "Votre panier est vide. Ajoutez les articles souhaités dans la boutique et réimportez.",
    "ex_cart_error": "Erreur lors de l'importation du panier.",
    "ex_submit": "Envoyer l'échange",
    "pickup_cost_label": "Coût de l'enlèvement :",
    "pickup_processed": "(facturé via la boutique en ligne)",
    "pickup_buy": "Acheter l'enlèvement",
    "success_title": "Demande envoyée avec succès",
    "success_msg": "Nous avons reçu votre demande et envoyé un e-mail de confirmation avec toutes les instructions et les prochaines étapes.",
    "success_ref": "Référence de la demande :",
    "err_not_found": "Commande introuvable ou e-mail incorrect.",
    "err_comm": "Erreur de communication. Veuillez réessayer.",
    "err_submit": "Impossible d'envoyer la demande. Veuillez réessayer.",
    "err_iban_required": "Indiquez l'IBAN et le nom du titulaire pour le remboursement.",
    "intransit_title": "Commande en route — pas encore livrée",
    "pickup_country_note": "*Valable uniquement pour le Portugal et l'Espagne continentale",
    "l_order": "Commande :",
    "l_email": "E-mail :",
    "l_payment": "Paiement :",
    "l_shipping": "Expédition :",
    "badge_paid": "Payé",
    "within14": "Dans les 14 jours",
    "outside14": "Hors du délai de 14 jours",
    "del_unfulfilled": "À expédier",
    "del_label_printed": "En préparation",
    "del_in_transit": "En transit",
    "del_out_for_delivery": "En cours de livraison",
    "del_delivered": "Livré",
    "del_fulfilled": "Expédié",
    "act_cancel_t": "Annuler la commande",
    "act_cancel_d": "La commande n'a pas encore été expédiée.",
    "act_withdraw_t": "Résilier / Annuler",
    "act_withdraw_d": "Droit de rétractation — refuser la livraison.",
    "act_return_t": "Retourner",
    "act_return_d": "Remboursement après réception et évaluation.",
    "act_exchange_t": "Échanger",
    "act_exchange_d": "Échanger contre d'autre(s) article(s).",
    "act_exchange_d_pre": "Changer d'article/taille avant l'expédition.",
    "item_ineligible": "Article non éligible",
    "rf_orig_original": "Remboursement sur le mode de paiement utilisé (carte, MB Way, PayPal ou Klarna).",
    "rf_iban_unavailable": "Indisponible — le remboursement est effectué sur le mode de paiement d'origine.",
    "rf_orig_ibanonly": "Valable uniquement pour carte, MB Way, PayPal ou Klarna.",
    "rf_iban_required": "Obligatoire pour Multibanco, virement bancaire ou Payshop.",
    "rf_orig_unknown": "Carte, MB Way, PayPal ou Klarna — sans données supplémentaires.",
    "rf_iban_unknown": "Nécessaire si le paiement ne peut pas être remboursé directement.",
    "continue_withdrawal": "Envoyer la rétractation",
    "continue_submit": "Envoyer la demande",
    "exch_recap_return": "Articles à retourner",
    "exch_recap_predispatch": "Articles à échanger",
    "vs_loading": "Chargement des options d'échange…",
    "vs_title": "Échanger contre (couleur / taille) :",
    "vs_fallback_cart": "Pour échanger cet article, utilisez « Importer du panier » ci-dessous.",
    "vs_no_variants": "Cet article n'a pas d'autres variantes. Pour échanger contre un autre article, utilisez « Importer du panier ».",
    "vs_unavailable": "Combinaison indisponible.",
    "vs_soldout": "Épuisé dans cette variante.",
    "vs_choosediff": "Choisissez une couleur ou une taille différente de l'actuelle.",
    "vs_new": "✓ Nouveau :",
    "exch_cart_empty": "Ajoutez au panier de la boutique les articles souhaités et cliquez sur « Importer du panier ».",
    "exch_cart_empty_err": "Votre panier est vide. Ajoutez les articles souhaités dans la boutique et réimportez.",
    "exch_cart_error": "Erreur lors de l'importation du panier.",
    "success_ref_label": "Référence de la demande :",
    "pickup_deduct_pre": "Nous déduirons",
    "pickup_deduct_post": "du montant à rembourser.",
    "pickup_buy_pre": "L'enlèvement coûte",
    "pickup_buy_post": ". Sur l'écran final, après confirmation de la demande, le lien pour acheter l'article d'enlèvement sera affiché.",
    "pickup_same_addr_q": "L'adresse d'enlèvement est-elle la même que celle de livraison ?",
    "pickup_same_yes": "Oui, c'est la même",
    "pickup_same_no": "Non, en indiquer une autre",
    "pickup_addr_name": "Nom du contact",
    "pickup_addr_name_ph": "Personne qui remet le colis au transporteur",
    "pickup_addr_phone": "Téléphone",
    "pickup_addr_phone_ph": "Pour contact du transporteur",
    "pickup_addr_line": "Adresse",
    "pickup_addr_line_ph": "Rue, numéro, étage",
    "pickup_addr_postal": "Code postal",
    "pickup_addr_postal_ph": "0000-000",
    "pickup_addr_city": "Ville",
    "pickup_addr_city_ph": "Ville",
    "pickup_day_label": "Quel est le meilleur jour pour l'enlèvement ?",
    "pickup_day_ph": "Exemples : le 20 janvier, mardis et jeudis",
    "pickup_note_title": "Important :",
    "pickup_note_body": "Les enlèvements sont effectués via CTT les jours ouvrables aux heures de bureau ; il n'est pas possible de programmer une heure précise. Les articles doivent être bien emballés dans une boîte ou une enveloppe fermée pour permettre un envoi en toute sécurité. Cela s'applique également aux boîtes à chaussures, qui doivent être emballées de manière à être protégées.",
    "err_pickup_addr_required": "Veuillez indiquer l'adresse d'enlèvement (adresse, code postal et ville).",
    "err_required_fields": "Veuillez remplir les champs obligatoires indiqués en rouge.",
    "ex_balance_title": "Ajustement du montant",
    "ex_balance_intro_refund": "Votre demande d'échange génère un montant en votre faveur, qui vous sera remboursé :",
    "ex_balance_intro_pay": "Votre demande d'échange génère un montant à payer :",
    "ex_balance_intro_even": "Votre échange ne génère aucun montant à régler.",
    "ex_balance_returned": "Retourné",
    "ex_balance_new": "Nouveau(x)",
    "ex_balance_refund": "à rembourser",
    "ex_balance_pay": "à payer",
    "ex_balance_even": "Rien à régler.",
    "ex_topay_note": "Un montant est à payer pour la différence. Notre équipe vous contactera ensuite avec les instructions de paiement.",
    "success_pickup_title": "L'enlèvement reste à programmer",
    "success_pickup_msg": "Pour finaliser la programmation de l'enlèvement, terminez l'achat ci-dessous. L'enlèvement n'est programmé qu'après le paiement.",
    "badge_partial": "Partielle",
    "grp_unfulfilled": "À expédier",
    "grp_in_transit": "En chemin",
    "grp_delivered": "Livré",
    "grp_tracking": "Suivi :",
    "choose_intro": "Sélectionnez les articles et indiquez ce que vous souhaitez faire pour chacun. Vous pouvez traiter ensemble ce qui est déjà expédié et ce qui reste à expédier.",
    "pick_action": "Que souhaitez-vous faire avec cet article ?",
    "pick_action_single": "Action :",
    "act_cancel_short": "Annuler",
    "act_return_short": "Retourner",
    "act_exchange_short": "Échanger",
    "act_refuse_short": "Refuser la livraison",
    "item_no_actions": "Aucune action disponible pour cet article.",
    "no_actions_title": "Aucune action disponible en ligne",
    "select_all": "Tout sélectionner",
    "exch_also_title": "Cette demande comprend également :",
    "existing_title": "Une demande existe déjà pour cette commande",
    "existing_msg": "Pour toute modification, contactez le service client par e-mail ou téléphone.",
    "existing_ref": "Référence :",
    "existing_date": "Soumis le",
    "existing_status": "Statut :",
    "existing_items_title": "Articles de la demande :",
    "existing_generic": "En cours d'analyse",
    "reqtype_return": "Retour",
    "reqtype_exchange": "Échange",
    "reqtype_cancellation": "Annulation",
    "reqtype_withdrawal": "Rétractation / Refus",
    "reqtype_mixed": "Demande mixte"
  },
  "de": {
    "grp_delivered_on": "Zugestellt am",
    "grp_window_expired": "Rückgabefrist abgelaufen",
    "c_title": "Rückgaben, Umtausch & Stornierungen",
    "c_intro": "Beantragen Sie Ihre Rückgabe, Ihren Umtausch oder Ihre Stornierung einfach im Formular unten.",
    "c_conditions": "<p>Der Umtausch- oder Rückgabeprozess ist einfach. Sie haben bis zu 14 Tage nach Erhalt der Bestellung Zeit, uns Ihre Umtausch- oder Rückgabeabsicht über dieses Formular mitzuteilen. Eine Stornierung wird nur vor dem Versand der Bestellung oder vor Beginn der Personalisierung der Artikel akzeptiert.</p><p>Nach dem Absenden Ihrer Anfrage müssen Sie uns den/die Artikel an die angegebene Adresse senden oder, sofern verfügbar, den im Formular angebotenen Abholservice wählen. Die Anfrage wird erst nach Erhalt und Prüfung der zurückgesandten Artikel bearbeitet.</p><p>Die Artikel müssen sich im Originalzustand befinden, ohne Anzeichen von Gebrauch, Wäsche, Gerüchen, Beschädigungen oder Veränderungen, und gegebenenfalls mit Originaletiketten, -verpackungen und -kartons.</p><p>Damit Ihre Anfrage korrekt bearbeitet werden kann, beachten Sie bitte:</p><ul><li>Geben Sie die Bestellnummer auf der Sendung, auf dem Karton oder mit einer Notiz im Inneren an;</li><li>Verpacken Sie die Artikel sicher in einem geschlossenen Karton oder Umschlag;</li><li>Bei Schuhen muss der Originalkarton mit einer Außenverpackung geschützt werden und darf nicht direkt als Versandkarton verwendet werden;</li><li>Umtausche werden in der Regel innerhalb von 5 Werktagen nach Erhalt und Prüfung der zurückgesandten Artikel bearbeitet;</li><li>Im Falle eines Umtauschs senden wir Ihnen nach Versand der neuen Sendung eine E-Mail mit der entsprechenden Sendungsverfolgungsnummer;</li><li>Rückerstattungen werden in der Regel innerhalb von 5 bis 8 Werktagen nach Prüfung der Rückgabe bearbeitet.</li><li>Bitte senden Sie keine Pakete, bevor Sie das Formular ausgefüllt haben</li></ul><p>Im Falle einer Rückerstattung wird der Betrag bei Zahlung mit Karte, PayPal, Klarna oder MB Way auf demselben Weg zurückerstattet. Wenn die Zahlung per Multibanco, Banküberweisung oder Payshop erfolgte, müssen Sie die IBAN und den Namen des Kontoinhabers angeben.</p>",
    "c_ineligible": "Personalisierte Artikel (mit Text oder Stickerei) und Intimartikel können nicht umgetauscht, zurückgegeben oder storniert werden.",
    "c_intransit": "<p>Ihre Bestellung wurde bereits versandt, aber noch nicht zugestellt. In dieser Phase können Sie über das Formular keinen Umtausch oder keine Rückgabe starten. Sie können die <strong>Annahme verweigern</strong>; die Rückerstattung oder der Umtausch wird erst nach Eintreffen der zurückgesandten Bestellung bearbeitet.</p>",
    "paid_badge": "Bezahlt",
    "remove": "Entfernen",
    "sending": "Senden…",
    "iban_ph": "PT50 0000 0000 0000 0000 0000 0",
    "holder_ph": "Vollständiger Name",
    "required_mark": "*",
    "step_order": "1 · Bestellung",
    "step_items": "2 · Artikel",
    "step_exchange": "3 · Umtausch",
    "order_number_label": "Bestellnummer",
    "order_number_ph": "z. B. 1001",
    "email_label": "Bestell-E-Mail",
    "email_ph": "sie@email.com",
    "help_prefix": "Sie kennen die Bestellnummer nicht? Sie finden sie in der",
    "help_email_word": "Bestellbestätigung",
    "help_received": "die Sie erhalten haben, oder",
    "help_account": "in Ihrem Konto.",
    "help_login": "durch Anmeldung in Ihrem Konto.",
    "search_btn": "Bestellung suchen",
    "searching": "Suche…",
    "conditions_title": "Rückgabe- und Umtauschbedingungen",
    "address_label": "Versandadresse:",
    "pickup_inline_label": "Abholung vor Ort",
    "pickup_inline_text": "wir können die Abholung des ordnungsgemäß verpackten Artikels veranlassen.",
    "pickup_link": "Link zur Artikelabholung",
    "policy_link": "Vollständige Rückgabe- und Umtauschrichtlinie ansehen",
    "summary_order": "Bestellung:",
    "summary_email": "E-Mail:",
    "summary_payment": "Zahlung:",
    "summary_shipping": "Versand:",
    "within_yes": "Innerhalb von 14 Tagen",
    "within_no": "Außerhalb der 14-Tage-Frist",
    "delivery_unfulfilled": "Nicht versandt",
    "delivery_label_printed": "Wird vorbereitet",
    "delivery_in_transit": "Unterwegs",
    "delivery_out_for_delivery": "In Zustellung",
    "delivery_delivered": "Zugestellt",
    "delivery_fulfilled": "Versandt",
    "actions_title": "Was möchten Sie tun?",
    "action_cancel_t": "Bestellung stornieren",
    "action_cancel_d": "Die Bestellung wurde noch nicht versandt.",
    "action_withdrawal_t": "Widerrufen / Stornieren",
    "action_withdrawal_d": "Widerrufsrecht — die Lieferung verweigern.",
    "action_return_t": "Zurückgeben",
    "action_return_d": "Rückerstattung nach Erhalt und Prüfung.",
    "action_exchange_t": "Umtauschen",
    "action_exchange_d_pre": "Artikel/Größe vor dem Versand ändern.",
    "action_exchange_d": "Gegen andere(n) Artikel umtauschen.",
    "no_actions": "Diese Bestellung erfüllt nicht die Bedingungen für Umtausch, Rückgabe oder Stornierung (außerhalb der 14-Tage-Frist oder bereits versandt). Im Zweifel kontaktieren Sie uns.",
    "items_title": "Wählen Sie die Artikel",
    "qty_ordered": "Bestellte Menge:",
    "qty": "Menge",
    "ineligible_fallback": "Artikel nicht zulässig",
    "shipping_title": "Wie senden Sie uns den/die Artikel?",
    "ship_self": "Selbst versenden",
    "ship_self_desc": "Per Einschreiben an die angegebene Adresse senden.",
    "ship_pickup": "Abholung vor Ort",
    "ship_pickup_desc": "Wir veranlassen die Abholung durch den Kurier.",
    "pickup_country_only": "Nur für Lieferungen in Portugal oder Spanien verfügbar.",
    "refund_title": "Rückerstattung",
    "refund_original": "Ursprüngliche Zahlungsart",
    "refund_original_desc": "Karte, MB Way, PayPal oder Klarna — keine zusätzlichen Angaben.",
    "refund_original_desc_ok": "Rückerstattung auf die verwendete Zahlungsart (Karte, MB Way, PayPal oder Klarna).",
    "refund_original_desc_iban": "Nur gültig für Karte, MB Way, PayPal oder Klarna.",
    "refund_iban": "Banküberweisung (IBAN)",
    "refund_iban_desc": "Erforderlich, wenn die Zahlung nicht direkt erstattet werden kann.",
    "refund_iban_desc_disabled": "Nicht verfügbar — die Rückerstattung erfolgt auf die ursprüngliche Zahlungsart.",
    "refund_iban_desc_required": "Erforderlich für Multibanco, Banküberweisung oder Payshop.",
    "iban_label": "IBAN",
    "iban_holder_label": "Name des Kontoinhabers",
    "notes_label": "Anmerkungen (optional)",
    "notes_ph": "z. B. Rückgabegrund, Hinweise…",
    "back": "Zurück",
    "submit_order": "Anfrage senden",
    "submit_withdrawal": "Widerruf senden",
    "continue_exchange": "Weiter zum Umtausch",
    "ex_recap_return": "Zurückzugebende Artikel",
    "ex_recap_swap": "Umzutauschende Artikel",
    "ex_mode_title": "Was möchten Sie im Umtausch?",
    "ex_mode_variant": "Gleicher Artikel, andere Farbe/Größe",
    "ex_mode_variant_desc": "Wählen Sie die neue Variante für jeden Artikel.",
    "ex_mode_different": "Ein anderer Artikel",
    "ex_mode_different_desc": "Importieren Sie die gewünschten Artikel aus dem Warenkorb.",
    "ex_loading": "Umtauschoptionen werden geladen…",
    "ex_swap_title": "Umtauschen gegen (Farbe / Größe):",
    "ex_no_handle": "Um diesen Artikel umzutauschen, verwenden Sie unten „Aus Warenkorb importieren“.",
    "ex_no_variants": "Dieser Artikel hat keine weiteren Varianten. Um gegen einen anderen Artikel umzutauschen, verwenden Sie „Aus Warenkorb importieren“.",
    "ex_status_unavailable": "Kombination nicht verfügbar.",
    "ex_status_sold_out": "In dieser Variante ausverkauft.",
    "ex_status_choose_diff": "Wählen Sie eine andere Farbe oder Größe als die aktuelle.",
    "ex_status_new": "✓ Neu:",
    "ex_cart_hint": "Legen Sie die gewünschten Artikel in den Warenkorb des Shops und klicken Sie auf „Aus Warenkorb importieren“. Sie können Mengen anpassen oder unten entfernen.",
    "ex_cart_empty_note": "Legen Sie die gewünschten Artikel in den Warenkorb des Shops und klicken Sie auf „Aus Warenkorb importieren“.",
    "ex_import_btn": "🛒 Aus Warenkorb importieren",
    "ex_cart_empty_err": "Ihr Warenkorb ist leer. Fügen Sie die gewünschten Artikel im Shop hinzu und importieren Sie erneut.",
    "ex_cart_error": "Fehler beim Importieren des Warenkorbs.",
    "ex_submit": "Umtausch senden",
    "pickup_cost_label": "Abholkosten:",
    "pickup_processed": "(über den Online-Shop berechnet)",
    "pickup_buy": "Abholung kaufen",
    "success_title": "Anfrage erfolgreich gesendet",
    "success_msg": "Wir haben Ihre Anfrage erhalten und eine Bestätigungs-E-Mail mit allen Anweisungen und den nächsten Schritten gesendet.",
    "success_ref": "Anfrage-Referenz:",
    "err_not_found": "Bestellung nicht gefunden oder falsche E-Mail.",
    "err_comm": "Kommunikationsfehler. Bitte versuchen Sie es erneut.",
    "err_submit": "Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    "err_iban_required": "Geben Sie IBAN und Kontoinhaber für die Rückerstattung an.",
    "intransit_title": "Bestellung unterwegs — noch nicht zugestellt",
    "pickup_country_note": "*Nur für das portugiesische und spanische Festland gültig",
    "l_order": "Bestellung:",
    "l_email": "E-Mail:",
    "l_payment": "Zahlung:",
    "l_shipping": "Versand:",
    "badge_paid": "Bezahlt",
    "within14": "Innerhalb von 14 Tagen",
    "outside14": "Außerhalb der 14-Tage-Frist",
    "del_unfulfilled": "Nicht versandt",
    "del_label_printed": "Wird vorbereitet",
    "del_in_transit": "Unterwegs",
    "del_out_for_delivery": "In Zustellung",
    "del_delivered": "Zugestellt",
    "del_fulfilled": "Versandt",
    "act_cancel_t": "Bestellung stornieren",
    "act_cancel_d": "Die Bestellung wurde noch nicht versandt.",
    "act_withdraw_t": "Widerrufen / Stornieren",
    "act_withdraw_d": "Widerrufsrecht — die Lieferung verweigern.",
    "act_return_t": "Zurückgeben",
    "act_return_d": "Rückerstattung nach Erhalt und Prüfung.",
    "act_exchange_t": "Umtauschen",
    "act_exchange_d": "Gegen andere(n) Artikel umtauschen.",
    "act_exchange_d_pre": "Artikel/Größe vor dem Versand ändern.",
    "item_ineligible": "Artikel nicht zulässig",
    "rf_orig_original": "Rückerstattung auf die verwendete Zahlungsart (Karte, MB Way, PayPal oder Klarna).",
    "rf_iban_unavailable": "Nicht verfügbar — die Rückerstattung erfolgt auf die ursprüngliche Zahlungsart.",
    "rf_orig_ibanonly": "Nur gültig für Karte, MB Way, PayPal oder Klarna.",
    "rf_iban_required": "Erforderlich für Multibanco, Banküberweisung oder Payshop.",
    "rf_orig_unknown": "Karte, MB Way, PayPal oder Klarna — keine zusätzlichen Angaben.",
    "rf_iban_unknown": "Erforderlich, wenn die Zahlung nicht direkt erstattet werden kann.",
    "continue_withdrawal": "Widerruf senden",
    "continue_submit": "Anfrage senden",
    "exch_recap_return": "Zurückzugebende Artikel",
    "exch_recap_predispatch": "Umzutauschende Artikel",
    "vs_loading": "Umtauschoptionen werden geladen…",
    "vs_title": "Umtauschen gegen (Farbe / Größe):",
    "vs_fallback_cart": "Um diesen Artikel umzutauschen, verwenden Sie unten „Aus Warenkorb importieren“.",
    "vs_no_variants": "Dieser Artikel hat keine weiteren Varianten. Um gegen einen anderen Artikel umzutauschen, verwenden Sie „Aus Warenkorb importieren“.",
    "vs_unavailable": "Kombination nicht verfügbar.",
    "vs_soldout": "In dieser Variante ausverkauft.",
    "vs_choosediff": "Wählen Sie eine andere Farbe oder Größe als die aktuelle.",
    "vs_new": "✓ Neu:",
    "exch_cart_empty": "Legen Sie die gewünschten Artikel in den Warenkorb des Shops und klicken Sie auf „Aus Warenkorb importieren“.",
    "exch_cart_empty_err": "Ihr Warenkorb ist leer. Fügen Sie die gewünschten Artikel im Shop hinzu und importieren Sie erneut.",
    "exch_cart_error": "Fehler beim Importieren des Warenkorbs.",
    "success_ref_label": "Anfrage-Referenz:",
    "pickup_deduct_pre": "Wir ziehen",
    "pickup_deduct_post": "vom zu erstattenden Betrag ab.",
    "pickup_buy_pre": "Die Abholung kostet",
    "pickup_buy_post": ". Auf dem letzten Bildschirm wird nach Bestätigung der Anfrage der Link zum Kauf des Abhol-Artikels angezeigt.",
    "pickup_same_addr_q": "Ist die Abholadresse dieselbe wie die Lieferadresse?",
    "pickup_same_yes": "Ja, dieselbe",
    "pickup_same_no": "Nein, andere angeben",
    "pickup_addr_name": "Kontaktname",
    "pickup_addr_name_ph": "Wer das Paket dem Kurier übergibt",
    "pickup_addr_phone": "Telefon",
    "pickup_addr_phone_ph": "Für den Kontakt des Kuriers",
    "pickup_addr_line": "Adresse",
    "pickup_addr_line_ph": "Straße, Nummer, Etage",
    "pickup_addr_postal": "Postleitzahl",
    "pickup_addr_postal_ph": "0000-000",
    "pickup_addr_city": "Ort",
    "pickup_addr_city_ph": "Ort",
    "pickup_day_label": "Welcher Tag passt am besten für die Abholung?",
    "pickup_day_ph": "Beispiele: 20. Januar, dienstags und donnerstags",
    "pickup_note_title": "Wichtig:",
    "pickup_note_body": "Die Abholungen erfolgen über CTT an Werktagen während der Geschäftszeiten; eine genaue Uhrzeit kann nicht vereinbart werden. Die Artikel müssen gut in einem geschlossenen Karton oder Umschlag verpackt sein, um einen sicheren Versand zu ermöglichen. Dies gilt auch für Schuhkartons, die so verpackt werden müssen, dass sie geschützt sind.",
    "err_pickup_addr_required": "Bitte geben Sie die Abholadresse an (Adresse, Postleitzahl und Ort).",
    "err_required_fields": "Bitte füllen Sie die rot markierten Pflichtfelder aus.",
    "ex_balance_title": "Betragsausgleich",
    "ex_balance_intro_refund": "Aus Ihrem Umtausch ergibt sich ein Betrag zu Ihren Gunsten, der Ihnen erstattet wird:",
    "ex_balance_intro_pay": "Aus Ihrem Umtausch ergibt sich ein zu zahlender Betrag:",
    "ex_balance_intro_even": "Aus Ihrem Umtausch ergibt sich kein auszugleichender Betrag.",
    "ex_balance_returned": "Zurückgegeben",
    "ex_balance_new": "Neue Artikel",
    "ex_balance_refund": "zu erstatten",
    "ex_balance_pay": "zu zahlen",
    "ex_balance_even": "Nichts auszugleichen.",
    "ex_topay_note": "Für die Differenz ist ein Betrag zu zahlen. Unser Team wird Sie anschließend mit den Zahlungsanweisungen kontaktieren.",
    "success_pickup_title": "Abholung muss noch geplant werden",
    "success_pickup_msg": "Um die Abholung abzuschließen, schließen Sie den Kauf unten ab. Die Abholung wird erst nach der Zahlung geplant."
  },
  "it": {
    "grp_delivered_on": "Consegnato il",
    "grp_window_expired": "Termine di reso scaduto",
    "c_title": "Resi, Cambi e Annullamenti",
    "c_intro": "Richiedi il tuo reso, cambio o annullamento in modo semplice nel modulo qui sotto.",
    "c_conditions": "<p>Il processo di cambio o reso è semplice. Hai fino a 14 giorni dalla ricezione dell'ordine per comunicarci l'intenzione di cambio o reso tramite questo modulo. In caso di annullamento, questo viene accettato solo prima della spedizione dell'ordine o prima dell'inizio della personalizzazione degli articoli.</p><p>Dopo aver inviato la richiesta, dovrai farci pervenire l'articolo/gli articoli all'indirizzo indicato oppure, ove applicabile, optare per il servizio di ritiro disponibile nel modulo. La richiesta sarà analizzata solo dopo la ricezione e la validazione degli articoli restituiti.</p><p>Gli articoli devono trovarsi in condizioni originali, senza segni di utilizzo, lavaggio, odori, danni o alterazioni e, ove applicabile, con etichette, imballaggi e scatole originali.</p><p>Per garantire la corretta elaborazione della richiesta, ti chiediamo di prestare attenzione a quanto segue:</p><ul><li>Indica il numero dell'ordine sulla spedizione, sulla scatola o con una nota all'interno;</li><li>Imballa gli articoli in modo sicuro in una scatola o busta chiusa;</li><li>Nel caso delle calzature, la scatola originale deve essere protetta con un imballaggio esterno e non deve essere utilizzata direttamente come scatola di spedizione;</li><li>I cambi vengono solitamente elaborati entro 5 giorni lavorativi dalla ricezione e validazione degli articoli restituiti;</li><li>In caso di cambio, una volta effettuata la nuova spedizione, ti invieremo un'email con il relativo numero di tracciamento;</li><li>I rimborsi vengono solitamente elaborati entro 5-8 giorni lavorativi dalla validazione del reso.</li><li>Si prega di non inviare pacchi prima di aver compilato il modulo</li></ul><p>In caso di rimborso, se il pagamento è stato effettuato con carta, PayPal, Klarna o MB Way, l'importo sarà rimborsato con lo stesso metodo. Se il pagamento è stato effettuato tramite Multibanco, bonifico bancario o Payshop, sarà necessario indicare l'IBAN e il nome dell'intestatario del conto.</p>",
    "c_ineligible": "Gli articoli personalizzati (con testo o ricami) e gli articoli intimi non possono essere cambiati, restituiti o annullati.",
    "c_intransit": "<p>Il tuo ordine è già stato spedito ma non è ancora stato consegnato. In questa fase non è possibile avviare cambi o resi tramite il modulo. Puoi <strong>rifiutare la consegna</strong>; il rimborso o il cambio saranno elaborati solo dopo l'arrivo dell'ordine restituito.</p>",
    "paid_badge": "Pagato",
    "remove": "Rimuovi",
    "sending": "Invio…",
    "iban_ph": "PT50 0000 0000 0000 0000 0000 0",
    "holder_ph": "Nome completo",
    "required_mark": "*",
    "step_order": "1 · Ordine",
    "step_items": "2 · Articoli",
    "step_exchange": "3 · Cambio",
    "order_number_label": "Numero dell'ordine",
    "order_number_ph": "Es: 1001",
    "email_label": "Email dell'ordine",
    "email_ph": "tu@email.com",
    "help_prefix": "Non conosci il numero dell'ordine? Lo trovi nell'",
    "help_email_word": "email di conferma",
    "help_received": "che hai ricevuto, oppure",
    "help_account": "nel tuo account.",
    "help_login": "accedendo al tuo account.",
    "search_btn": "Cerca ordine",
    "searching": "Ricerca…",
    "conditions_title": "Condizioni di cambio e reso",
    "address_label": "Indirizzo di spedizione:",
    "pickup_inline_label": "Ritiro a domicilio",
    "pickup_inline_text": "possiamo programmare il ritiro dell'articolo, adeguatamente imballato.",
    "pickup_link": "Link per il ritiro degli articoli",
    "policy_link": "Vedi la politica completa di resi e cambi",
    "summary_order": "Ordine:",
    "summary_email": "Email:",
    "summary_payment": "Pagamento:",
    "summary_shipping": "Spedizione:",
    "within_yes": "Entro 14 giorni",
    "within_no": "Oltre il termine di 14 giorni",
    "delivery_unfulfilled": "Da spedire",
    "delivery_label_printed": "In preparazione",
    "delivery_in_transit": "In transito",
    "delivery_out_for_delivery": "In consegna",
    "delivery_delivered": "Consegnato",
    "delivery_fulfilled": "Spedito",
    "actions_title": "Cosa desideri fare?",
    "action_cancel_t": "Annulla ordine",
    "action_cancel_d": "L'ordine non è ancora stato spedito.",
    "action_withdrawal_t": "Recedi / Annulla",
    "action_withdrawal_d": "Diritto di recesso — rifiutare la consegna.",
    "action_return_t": "Restituisci",
    "action_return_d": "Rimborso dopo ricezione e valutazione.",
    "action_exchange_t": "Cambia",
    "action_exchange_d_pre": "Cambiare articolo/taglia prima della spedizione.",
    "action_exchange_d": "Cambiare con altro/i articolo/i.",
    "no_actions": "Questo ordine non soddisfa le condizioni per cambio, reso o annullamento (oltre il termine di 14 giorni o già spedito). In caso di dubbio, contattaci.",
    "items_title": "Seleziona gli articoli",
    "qty_ordered": "Q.tà ordinata:",
    "qty": "Q.tà",
    "ineligible_fallback": "Articolo non idoneo",
    "shipping_title": "Come ci fai pervenire l'articolo/gli articoli?",
    "ship_self": "Spedizione a tua cura",
    "ship_self_desc": "Spedisci tramite raccomandata all'indirizzo indicato.",
    "ship_pickup": "Ritiro a domicilio",
    "ship_pickup_desc": "Programmiamo il ritiro tramite corriere.",
    "pickup_country_only": "Disponibile solo per consegne in Portogallo o Spagna.",
    "refund_title": "Rimborso",
    "refund_original": "Metodo di pagamento originale",
    "refund_original_desc": "Carta, MB Way, PayPal o Klarna — senza dati aggiuntivi.",
    "refund_original_desc_ok": "Rimborso sullo stesso metodo di pagamento utilizzato (carta, MB Way, PayPal o Klarna).",
    "refund_original_desc_iban": "Valido solo per carta, MB Way, PayPal o Klarna.",
    "refund_iban": "Bonifico bancario (IBAN)",
    "refund_iban_desc": "Necessario se il pagamento non può essere rimborsato direttamente.",
    "refund_iban_desc_disabled": "Non disponibile — il rimborso viene effettuato sul metodo di pagamento originale.",
    "refund_iban_desc_required": "Obbligatorio per Multibanco, bonifico bancario o Payshop.",
    "iban_label": "IBAN",
    "iban_holder_label": "Nome dell'intestatario",
    "notes_label": "Note (facoltativo)",
    "notes_ph": "Es: motivo del reso, indicazioni…",
    "back": "Indietro",
    "submit_order": "Invia richiesta",
    "submit_withdrawal": "Invia recesso",
    "continue_exchange": "Continua verso il cambio",
    "ex_recap_return": "Articoli da restituire",
    "ex_recap_swap": "Articoli da cambiare",
    "ex_mode_title": "Cosa desideri in cambio?",
    "ex_mode_variant": "Stesso articolo, altro colore/taglia",
    "ex_mode_variant_desc": "Scegli la nuova variante di ogni articolo.",
    "ex_mode_different": "Un articolo diverso",
    "ex_mode_different_desc": "Importa dal carrello gli articoli desiderati.",
    "ex_loading": "Caricamento opzioni di cambio…",
    "ex_swap_title": "Cambia con (colore / taglia):",
    "ex_no_handle": "Per cambiare questo articolo, usa «Importa dal carrello» qui sotto.",
    "ex_no_variants": "Questo articolo non ha altre varianti. Per cambiare con un altro articolo, usa «Importa dal carrello».",
    "ex_status_unavailable": "Combinazione non disponibile.",
    "ex_status_sold_out": "Esaurito in questa variante.",
    "ex_status_choose_diff": "Scegli un colore o una taglia diversi da quelli attuali.",
    "ex_status_new": "✓ Nuovo:",
    "ex_cart_hint": "Aggiungi al carrello del negozio gli articoli desiderati e clicca su «Importa dal carrello». Puoi modificare le quantità o rimuovere qui sotto.",
    "ex_cart_empty_note": "Aggiungi al carrello del negozio gli articoli desiderati e clicca su «Importa dal carrello».",
    "ex_import_btn": "🛒 Importa dal carrello",
    "ex_cart_empty_err": "Il tuo carrello è vuoto. Aggiungi gli articoli desiderati nel negozio e importa di nuovo.",
    "ex_cart_error": "Errore durante l'importazione del carrello.",
    "ex_submit": "Invia cambio",
    "pickup_cost_label": "Costo del ritiro:",
    "pickup_processed": "(addebitato tramite il negozio online)",
    "pickup_buy": "Acquista ritiro",
    "success_title": "Richiesta inviata con successo",
    "success_msg": "Abbiamo ricevuto la tua richiesta e inviato un'email di conferma con tutte le istruzioni e i prossimi passi.",
    "success_ref": "Riferimento della richiesta:",
    "err_not_found": "Ordine non trovato o email errata.",
    "err_comm": "Errore di comunicazione. Riprova.",
    "err_submit": "Impossibile inviare la richiesta. Riprova.",
    "err_iban_required": "Indica l'IBAN e il nome dell'intestatario per il rimborso.",
    "intransit_title": "Ordine in arrivo — non ancora consegnato",
    "pickup_country_note": "*Valido solo per Portogallo e Spagna continentale",
    "l_order": "Ordine:",
    "l_email": "Email:",
    "l_payment": "Pagamento:",
    "l_shipping": "Spedizione:",
    "badge_paid": "Pagato",
    "within14": "Entro 14 giorni",
    "outside14": "Oltre il termine di 14 giorni",
    "del_unfulfilled": "Da spedire",
    "del_label_printed": "In preparazione",
    "del_in_transit": "In transito",
    "del_out_for_delivery": "In consegna",
    "del_delivered": "Consegnato",
    "del_fulfilled": "Spedito",
    "act_cancel_t": "Annulla ordine",
    "act_cancel_d": "L'ordine non è ancora stato spedito.",
    "act_withdraw_t": "Recedi / Annulla",
    "act_withdraw_d": "Diritto di recesso — rifiutare la consegna.",
    "act_return_t": "Restituisci",
    "act_return_d": "Rimborso dopo ricezione e valutazione.",
    "act_exchange_t": "Cambia",
    "act_exchange_d": "Cambiare con altro/i articolo/i.",
    "act_exchange_d_pre": "Cambiare articolo/taglia prima della spedizione.",
    "item_ineligible": "Articolo non idoneo",
    "rf_orig_original": "Rimborso sullo stesso metodo di pagamento utilizzato (carta, MB Way, PayPal o Klarna).",
    "rf_iban_unavailable": "Non disponibile — il rimborso viene effettuato sul metodo di pagamento originale.",
    "rf_orig_ibanonly": "Valido solo per carta, MB Way, PayPal o Klarna.",
    "rf_iban_required": "Obbligatorio per Multibanco, bonifico bancario o Payshop.",
    "rf_orig_unknown": "Carta, MB Way, PayPal o Klarna — senza dati aggiuntivi.",
    "rf_iban_unknown": "Necessario se il pagamento non può essere rimborsato direttamente.",
    "continue_withdrawal": "Invia recesso",
    "continue_submit": "Invia richiesta",
    "exch_recap_return": "Articoli da restituire",
    "exch_recap_predispatch": "Articoli da cambiare",
    "vs_loading": "Caricamento opzioni di cambio…",
    "vs_title": "Cambia con (colore / taglia):",
    "vs_fallback_cart": "Per cambiare questo articolo, usa «Importa dal carrello» qui sotto.",
    "vs_no_variants": "Questo articolo non ha altre varianti. Per cambiare con un altro articolo, usa «Importa dal carrello».",
    "vs_unavailable": "Combinazione non disponibile.",
    "vs_soldout": "Esaurito in questa variante.",
    "vs_choosediff": "Scegli un colore o una taglia diversi da quelli attuali.",
    "vs_new": "✓ Nuovo:",
    "exch_cart_empty": "Aggiungi al carrello del negozio gli articoli desiderati e clicca su «Importa dal carrello».",
    "exch_cart_empty_err": "Il tuo carrello è vuoto. Aggiungi gli articoli desiderati nel negozio e importa di nuovo.",
    "exch_cart_error": "Errore durante l'importazione del carrello.",
    "success_ref_label": "Riferimento della richiesta:",
    "pickup_deduct_pre": "Detrarremo",
    "pickup_deduct_post": "dall'importo da rimborsare.",
    "pickup_buy_pre": "Il ritiro ha un costo di",
    "pickup_buy_post": ". Nella schermata finale, dopo aver confermato la richiesta, sarà mostrato il link per acquistare l'articolo di ritiro.",
    "pickup_same_addr_q": "L'indirizzo di ritiro è lo stesso della consegna?",
    "pickup_same_yes": "Sì, è lo stesso",
    "pickup_same_no": "No, indicarne un altro",
    "pickup_addr_name": "Nome del contatto",
    "pickup_addr_name_ph": "Chi consegna il pacco al corriere",
    "pickup_addr_phone": "Telefono",
    "pickup_addr_phone_ph": "Per il contatto del corriere",
    "pickup_addr_line": "Indirizzo",
    "pickup_addr_line_ph": "Via, numero, piano",
    "pickup_addr_postal": "Codice postale",
    "pickup_addr_postal_ph": "0000-000",
    "pickup_addr_city": "Località",
    "pickup_addr_city_ph": "Località",
    "pickup_day_label": "Qual è il giorno migliore per il ritiro?",
    "pickup_day_ph": "Esempi: 20 gennaio, martedì e giovedì",
    "pickup_note_title": "Importante:",
    "pickup_note_body": "I ritiri vengono effettuati tramite CTT nei giorni lavorativi in orario d'ufficio; non è possibile programmare un orario. Gli articoli devono essere ben imballati in una scatola o busta chiusa per consentire una spedizione sicura. Questo vale anche per le scatole delle scarpe, che dovranno essere imballate in modo da essere protette.",
    "err_pickup_addr_required": "Indicare l'indirizzo di ritiro (indirizzo, codice postale e località).",
    "err_required_fields": "Compila i campi obbligatori evidenziati in rosso.",
    "ex_balance_title": "Conguaglio importi",
    "ex_balance_intro_refund": "Dalla tua richiesta di cambio risulta un importo a tuo favore, che ti sarà rimborsato:",
    "ex_balance_intro_pay": "Dalla tua richiesta di cambio risulta un importo da pagare:",
    "ex_balance_intro_even": "Dal tuo cambio non risulta alcun importo da regolare.",
    "ex_balance_returned": "Reso",
    "ex_balance_new": "Nuovo/i",
    "ex_balance_refund": "da rimborsare",
    "ex_balance_pay": "da pagare",
    "ex_balance_even": "Nessun importo da regolare.",
    "ex_topay_note": "C'è un importo da pagare per la differenza. Sarà comunicato successivamente dal nostro team, con le istruzioni di pagamento.",
    "success_pickup_title": "Il ritiro deve ancora essere programmato",
    "success_pickup_msg": "Per completare la programmazione del ritiro, completa l'acquisto qui sotto. Il ritiro viene programmato solo dopo il pagamento."
  }
};
